export default __webpack_public_path__ + "static/media/EstacoesIconEdit.a5de0529.svg";